(function () {
  angular.module('app.referral-analytics.subject-grade-comparisons', []);

})();